export const GET_BATTERY_LIST = 'GET_BATTERY_LIST';
export const SET_BATTERY_LIST = 'SET_BATTERY_LIST';
export const SET_SELECTED_BATTERY = 'SET_SELECTED_BATTERY';
export const GET_BATTERY_DETAIL = 'GET_BATTERY_DETAIL';
export const SET_BATTERY_DETAIL = 'SET_BATTERY_DETAIL';
export const INSERT_BATTERY = 'INSERT_BATTERY';
export const UPDATE_BATTERY = 'UPDATE_BATTERY';
export const DELETE_BATTERY = 'DELETE_BATTERY';
